module.exports = __webpack_public_path__ + "img/Stage_4.90a353be.svg";